import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AgentLayout from './AgentLayout';
import ClientLayout from './ClientLayout';

const RoleBasedLayout = ({ isDark, toggleTheme }) => {
  const { user } = useAuth();

  if (user?.role === 'agent') {
    return <AgentLayout isDark={isDark} toggleTheme={toggleTheme} />;
  }

  return <ClientLayout isDark={isDark} toggleTheme={toggleTheme} />;
};

export default RoleBasedLayout;
